module.exports = __webpack_public_path__ + "img/Milkshake.eb6e2073.webp";